import cloneDeep from "lodash/cloneDeep";
import { PLATFORM_SOURCE } from "./constants/payment";
import { parseAsPathParams } from "./route";
import QS from "qs";
import { orderByDate } from "./date";
import {
  PAGE_VIEWS_ORDER,
  LINK_VIEWS_ORDER,
  SETUP_LINK_VIEWS_ORDER
} from "utils/constants/dashboard";
import { isSetupShortLink } from "utils/shortLink";
import compact from "lodash/compact";

/**
 * Fetch events
 * - subdomain is required as is used to determine authorized access
 * - Extend with route or shortId if present
 */
export const getComputationInput = ({
  subdomain,
  route,
  shortId,
  testShortId,
  livemode
}) => {
  if (route) {
    return {
      subdomain,
      route
    };
  } else if (shortId && livemode) {
    return {
      subdomain,
      shortId
    };
  } else if (testShortId && !livemode) {
    return {
      subdomain,
      shortId: testShortId
    };
  }
};

export const prepareResourceRouteAndValues = ({
  values,
  value,
  testId,
  source,
  asPath
}) => {
  const updatedValues = cloneDeep(values);

  /**
   * To correctly scope event fetching
   * We need to only have either the shortId or route set in context at any one time
   * So we do a set/unset here
   */
  const asPathParts = asPath.split("?");
  const routeParams = parseAsPathParams(asPath);
  if (source === PLATFORM_SOURCE.LINK) {
    updatedValues.route = "";
    updatedValues.shortId = value;
    updatedValues.testShortId = testId;

    delete routeParams.route;
    routeParams.shortId = value;
  } else if (source === PLATFORM_SOURCE.PAGE) {
    updatedValues.route = value;
    updatedValues.shortId = "";
    updatedValues.testShortId = "";

    delete routeParams.shortId;
    routeParams.route = value;
  }

  const updatedRoute = `${asPathParts[0]}?${QS.stringify(routeParams)}`;

  return {
    values: updatedValues,
    route: updatedRoute
  };
};

export const getDashboardInitialValues = ({
  subdomain,
  alias,
  asPath = "",
  shortLinks = [],
  liveManifests = []
}) => {
  const latestLiveManifest = orderByDate(
    liveManifests,
    "created_at",
    "desc"
  )[0];
  const latestShortLink = orderByDate(shortLinks, "created_at", "desc")[0];

  const result = {
    subdomain,
    alias,
    source: null
  };
  const [newest] = orderByDate(
    compact([latestLiveManifest, latestShortLink]),
    "created_at",
    "desc"
  );

  const currentParams = parseAsPathParams(asPath);
  if (currentParams && currentParams.shortId) {
    result.source = PLATFORM_SOURCE.LINK;
    result.shortId = currentParams.shortId;
  } else if (currentParams && currentParams.route) {
    result.source = PLATFORM_SOURCE.PAGE;
    result.route = currentParams.route;
  } else if (newest) {
    const isShortLink = newest.short_id;
    if (isShortLink) {
      result.source = PLATFORM_SOURCE.LINK;
      result.shortId = newest.short_id;
      result.testShortId = newest.test_short_id || "";
    } else {
      result.source = PLATFORM_SOURCE.PAGE;
      result.route = newest.route;
    }
  }

  if (result.shortId && !result.testShortId) {
    const shortLinkMatch = shortLinks.find(
      ({ short_id }) => short_id === result.shortId
    );
    if (shortLinkMatch && shortLinkMatch.test_short_id) {
      result.testShortId = shortLinkMatch.test_short_id;
    }
  }

  return result;
};

export const getViewsOrder = ({ values, shortLinks = [] }) => {
  const shortLink = shortLinks.find(
    ({ short_id }) => short_id === values.shortId
  );
  let viewsOrder = [];
  if (values.subdomain) {
    if (values.route) {
      viewsOrder = PAGE_VIEWS_ORDER;
    } else if (values.shortId) {
      viewsOrder = isSetupShortLink(shortLink)
        ? SETUP_LINK_VIEWS_ORDER
        : LINK_VIEWS_ORDER;
    }
  }

  return viewsOrder;
};
